export default "__VITE_ASSET__e32f34e9__"